<template>
  <div class="main-wrapper">
    <import-task ref="importTask">
      <template slot="header">
        <search-box class="search-box">
          <el-form :inline="true" size="mini">
            <el-form-item label="日期">
              <form-date-range
                :form="form"
                startKey="startDate"
                :usingTime="false"
                endKey="endDateStr"
                valueFormat="yyyy-MM-dd HH:mm:ss"
              ></form-date-range>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
          </template>
        </search-box>
      </template>
      <template slot="main-header">
        <el-button type="primary" size="mini" @click="showExport">批量导入</el-button>
      </template>
    </import-task>
    <el-dialog :title="titleName" width="60%;" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div slot="footer" class="dialog-footer">
        <el-form :model="requestParam" :rules="rules" ref="requestParam" label-width="60px">
          <el-row>
            <el-col :span="24" align="left">
              <el-form-item label="附件" prop="goodsCode">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  accept=".xls,.xlsx,.xls.ttt,.xlsx.ttt"
                  :limit="1"
                  action=""
                  :http-request="httpRequest"
                  :on-remove="handleRemove"
                  :headers="headers"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                >
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <el-button
                    style="margin-left: 10px"
                    v-loading.fullscreen.lock="fjLoading"
                    element-loading-text="数据导入中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    size="small"
                    type="success"
                    @click="checkFormValid"
                  >
                    上传
                  </el-button>
                  <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且只能上传一个</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button @click="cancel" size="medium">取 消</el-button>
      </div>
    </el-dialog>
    <prompt-dialog :visible.sync="promptVisible" :taskId="taskId" v-if="promptVisible" @success="handleSearch" />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
import moment from 'moment';
import pagePathMixin from '@/utils/page-path-mixin';
import promptDialog from './components/prompt-dialog.vue';
export default {
  mixins: [pagePathMixin],
  components: {
    promptDialog,
  },
  data() {
    return {
      form: {
        startDate: '',
        endDate: '',
        endDateStr: '',
        reportName: '',
        appCode: 'ec-pc-new',
      },
      dialogFormVisible: false,
      promptVisible: false,
      titleName: '',
      requestParam: {},
      headers: {
        Authorization: getToken(),
      },
      fileList: [],
      rules: {},
      fjLoading: false,
      taskId: '',
    };
  },
  computed: {},
  methods: {
    handleSearch() {
      this.form.endDate =
        this.form.endDateStr == null || this.form.endDateStr == '' ? this.form.endDateStr : this.form.endDateStr.substr(0, 10) + ' 23:59:59';
      this.$refs['importTask'].init(this.form);
    },
    handleReset() {
      this.form = {
        startDate: '',
        endDate: '',
        endDateStr: '',
        reportName: '',
        appCode: 'ec-pc-new',
      };
      this.handleSearch();
    },
    showExport() {
      this.fileList = [];
      this.dialogFormVisible = true;
      let filename = this.$route.query.fileName;
      filename = filename.substring(0, filename.lastIndexOf('.'));
      this.titleName = filename + '批量维护';
    },
    cancel() {
      this.dialogFormVisible = false;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      console.log(file, fileList);
    },
    httpRequest(file) {},
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.cancel();
      this.handleSearch();
    },
    // 验证
    beforeUpload(file) {
      // .xls,.xlsx,.xls.ttt,.xlsx.ttt
      let pattern = file.name.substring(file.name.lastIndexOf('.') + 1);
      if (['xls', 'xlsx', 'xls.ttt', 'xlsx.ttt'].indexOf(pattern.toLowerCase()) === -1) {
        this.$message.error('请上传后缀名为.xls,.xlsx的附件！');
        return false;
      }
      this.fileList = [];
      this.fileList.push(file);
    },
    checkFormValid(file) {
      this.$refs['requestParam'].validate(valid => {
        if (valid) {
          this.submitUpload(file);
        } else {
          this.$message.error('参数校验失败！');
        }
      });
    },
    submitUpload(file) {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error('请先上传Excel附件');
        return;
      }
      this.fjLoading = true;

      let taskDTO = null;
      let fields = [
        {
          columnName: '日期',
          columnValue: this.requestParam.planTime,
          fieldName: 'planTime',
          fieldValue: this.requestParam.planTime,
          relation: 'planTime',
        },
      ];
      taskDTO = {
        reportName: this.form.reportName,
        appCode: 'ec-pc-new',
        paramMap: [],
      };

      this.$q.common
        .uploadFile({
          data: {
            file: this.fileList[0],
            taskDTO: JSON.stringify(taskDTO),
          },
        })
        .then(res => {
          if (res.success) {
            this.$message.success('数据导入中，请稍后');
            this.getImportStatus(res.data);
          } else {
            this.$message.error(res.message);
            this.fjLoading = false;
          }
          this.cancel();
          this.handleSearch();
        });
    },
    // 拿到导入taskId轮询根据后台返回字段 是否弹窗二次申请 不弹就提示成功
    getImportStatus(taskId) {
      this.taskId = taskId;
      var _this = this;
      var timer = setInterval(() => {
        _this.$q.goods
          .goodsLivePriceImportStatus({ fragment: [taskId] }) 
          .then(res => {
            const status = res.data.status;
            // status: 1和4-导入失败, 2-导入成功, 3-需要弹窗
            if (status == 2) {
              // 导入成功
              clearInterval(timer);
              _this.fjLoading = false;
              _this.$message.success('数据导入成功');
              _this.handleSearch();
            } else if (status == 3) {
              // 弹出组件弹窗
              clearInterval(timer);
              _this.fjLoading = false;
              _this.promptVisible = true;
            } else if (status == 1 || status == 4) {
              // 导入失败
              clearInterval(timer);
              _this.fjLoading = false;
              _this.$message.error('数据导入失败');
              _this.handleSearch();
            }
          })
          .catch(err => {
            clearInterval(timer);
            _this.fjLoading = false;
            _this.$message.error(err.message);
          });
      }, 5000);
    },
  },
  mounted() {
    this.form.reportName = this.$route.query.reportName;
    this.handleSearch();
  },
};
</script>

<style lang="stylus" scoped>
.main-wrapper
  height calc(100vh - 65px)
.root
  padding 5px
>>> .el-header
  height: 39px !important
  margin-bottom: 5px
  padding 0
</style>
